import styled from 'styled-components';
import {MinMaxBetAmountDefaultBox} from './min-max-bet-amount.default.box';

export const MinMaxBetAmountSIBox = styled(MinMaxBetAmountDefaultBox) `
    color: ${({theme}) => theme.colors.textLight};
    ${({theme}) => theme.font.presets.bold};
`;
